// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__27YPT","paramInput":"JobSimulator_paramInput__3kb4b","input":"JobSimulator_input__B6V6N"};